module.exports = __webpack_public_path__ + "static/media/robinhood.aa91f194.png";